import {parsePhoneNumberWithError} from 'libphonenumber-js';

const tryConversionToE164Format = (input, allowedCountries=['CA']) => {
  const defaultCountry = allowedCountries[0] || 'CA';

  try {
    const phoneNumber = parsePhoneNumberWithError(input, defaultCountry);

    if (!phoneNumber.isValid()) {
      return {
        originalPhoneNumber: input,
        e164Format: null,
        isValid: false,
        reasonNotValid: 'Invalid phone number',
      };
    }

    if (!allowedCountries.includes(phoneNumber.country)) {
      let reasonNotValid = 'Invalid phone number';

      if (allowedCountries.length === 1 && allowedCountries[0] === 'CA') {
        reasonNotValid = 'Only Canadian numbers are allowed';
      } else if (allowedCountries.length === 2 && allowedCountries[0] === 'CA' && allowedCountries[1] === 'US') {
        reasonNotValid = 'Only Canadian and US numbers are allowed';
      } else {
        const allowedCountryLabels = {
          CA: 'Canadian',
          US: 'US',
        };
        const countryLabels = allowedCountries.map((country) => allowedCountryLabels[country] || country);
        reasonNotValid = `Only ${countryLabels.join(' and ')} numbers are allowed`;
      }

      return {
        originalPhoneNumber: input,
        e164Format: null,
        isValid: false,
        reasonNotValid,
      };
    }

    return {
      originalPhoneNumber: input,
      e164Format: phoneNumber.format('E.164'),
      isValid: true,
      reasonNotValid: null,
    };
  } catch (error) {
    return {
      originalPhoneNumber: input,
      e164Format: null,
      isValid: false,
      reasonNotValid: error?.message || 'Invalid phone number',
    };
  }
};

export default tryConversionToE164Format;
